module.exports = "https://static.wagwalking.com/_next/static/images/dog-boarding-2-5f36e8e68f84729fa4d4be54792ffdb1.svg";